export default __webpack_public_path__ + "static/key-findings-figure-1-2025-f61851d941a00e3cf5f5e1cda6ef5546.png";